const DEFAULT_PHONE = '584123964576';

/** Convierte 0414… o 58414… al formato wa.me (solo dígitos, código país 58). */
function normalizeWhatsAppPhone(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return DEFAULT_PHONE;
  if (digits.startsWith('58')) return digits;
  if (digits.startsWith('0')) return `58${digits.slice(1)}`;
  return digits;
}

function buildMessageWithPagePreview() {
  if (typeof window === 'undefined') {
    return 'Hola, quiero anunciar en TNO Network.';
  }
  const url = window.location.href.split('#')[0].replace(/\?+$/, '');
  const title = (typeof document !== 'undefined' && document.title && document.title.trim()) || 'TNO Network | Media Kit';
  return ['Hola, quiero anunciar en TNO Network.', '', title, '', url].join('\n');
}

/**
 * Abre WhatsApp con mensaje que incluye título de la página + URL para que el chat
 * muestre preview (og:title / og:image) del media kit o ruta actual.
 * @param {MouseEvent} [_evt] — si viene de onClick, se ignora
 * @param {string} [customText] — mensaje fijo (opcional)
 * @param {string} [phone] — teléfono destino (ej. 04141355751); por defecto comercial TNO
 */
const handleOpenWhatsApp = (_evt, customText, phone) => {
  const message = typeof customText === 'string' && customText.trim() ? customText.trim() : buildMessageWithPagePreview();
  const waPhone = normalizeWhatsAppPhone(phone || DEFAULT_PHONE);
  const whatsappUrl = `https://wa.me/${waPhone}?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
};

export default handleOpenWhatsApp;